import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button, Alert } from "react-bootstrap";
import history from "../../history";

import { getSetupInfo, deleteVc } from "../../actions";
import Layout from "../layout";
import ErrorModal from "../error/ErrorModal";
import Loading from "../loading";

class DeleteVc extends Component {
  state = {
    path: "/admin/delete",
    vcid: "",
    error: false,
    hasSubmit: false,
  };

  componentDidMount = async () => {
    const { vcid } = this.props.computedMatch.params;
    this.setState({ vcid });
    if (!this.props.setupTimes) await this.props.getSetupInfo();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const prevState = { ...this.state };
    this.setState({ hasSubmit: !prevState.hasSubmit });

    this.props.deleteVc(prevState.vcid);
  };

  createPropList = (vcInfo) => {
    if (vcInfo) {
      const vcInfoArray = Object.entries(vcInfo);
      const list = vcInfoArray
        .filter((key) => {
          return key[0] !== "VCID";
        })
        .map((key) => {
          return (
            <li key={key[0]}>
              {key[0]}: <strong>{key[1]}</strong>
            </li>
          );
        });
      return <ul>{list}</ul>;
    }
  };

  createConf() {
    const rows = this.props.setupTimes;

    const vcRow = rows.filter((row) => row.VCID === this.state.vcid)[0];
    const propList = this.createPropList(vcRow);

    return (
      <Modal.Dialog>
        <Modal.Header>
          <Modal.Title>Delete {this.state.vcid}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete {this.state.vcid}?</p>
          {propList}
          {this.props.error && this.state.path === this.props.path && (
            <Alert variant="danger" className="mt-3 text-center">
              {this.props.errorDescription}
            </Alert>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              history.push("/admin");
            }}
            disabled={this.state.hasSubmit && !this.props.error}
          >
            Close
          </Button>
          <Button
            variant="danger"
            onClick={this.handleSubmit}
            disabled={this.state.hasSubmit}
          >
            {this.state.hasSubmit && !this.props.error
              ? "Loading..."
              : "Delete"}
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    );
  }

  renderContent() {
    if (this.props.setupTimes) {
      const rows = this.props.setupTimes;
      if (!Array.isArray(rows) || !rows.length) {
        return <ErrorModal />;
      } else {
        return this.createConf();
      }
    } else {
      return <Loading />;
    }
  }

  render() {
    return <Layout title="Delete Vote Center">{this.renderContent()}</Layout>;
  }
}

const mapStateToProps = (state) => {
  return {
    setupTimes: state.admin.setupTimes,
    error: state.admin.error,
    errorDescription: state.admin.errorDescription,
    path: state.admin.path,
  };
};

export default connect(mapStateToProps, { getSetupInfo, deleteVc })(DeleteVc);
